export default "__VITE_ASSET__DQfZtYiN__"